<!--  -->
<template>
  <div class="upload">
    <ul class="upload-content">
      <li v-for="(src, item) in images" :key="item">
        <a v-if="src">
          <img :src="src" alt="" @click="toUpload(item)">
          <em :class="{iconclose:true}" @click="deleteImages(item)"></em>
        </a>
      </li>
      <li v-if="value.length < maxLen">
        <a>
          <img alt="" @click="toUpload()">
          <em :class="{iconclose:false}"></em>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Array,
      required: true
    },
    // 最大可以上传数量
    maxLen: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      images: []
    }
  },
  created() {
    this.images = JSON.parse(JSON.stringify(this.value))
  },
  methods: {
    toUpload(item) {
      this.$wechat.promise.then(wx => {
        wx.uploadImage((res) => {
          let mediaId = res.serverId
          // 通知后台同步刚上传的文件
          this.$rest.wx.getImageByAuction(null, mediaId).then((res) => {
            if (res.code === 0) {
              if (typeof item !== 'undefined') {
                this.$set(this.images, item, res.data.url)
              } else {
                this.$set(this.images, this.images.length, res.data.url)
              }
              this.emitImages()
            } else {
              this.showToast(res.message)
            }
          })
        })
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
    },
    deleteImages(item) {
      this.images.splice(item, 1)
      this.emitImages()
    },
    emitImages() {
      this.$emit('input', JSON.parse(JSON.stringify(this.images)))
    }
  }
}
</script>
<style lang='less' scoped>
@import url('../../stylesheets/base/fn.less');
.upload {
  &-content {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    li {
      flex-basis: 150 / @w2;
      width: 150 / @w2;
      height: 150 / @w2;
      margin: 30 / @w2 30 / @w2 0 0;
      a {
        position: relative;
        display: block;
        width: 150 / @w2;
        height: 150 / @w2;
        max-height: 150 / @w2;
        color: #000;
        text-align: center;
        background: url('../../stylesheets/images/upload_bg.png') no-repeat;
        background-size: 100% 100%;
        .radius(8/@w2);
        img {
          display: inline-block;
          width: 100%;
          font-size: 0;
          height: 100%;
          .radius(8/@w2);
        }
        img:not([src]) {
          opacity: 0;
          display: inline-block;
          height: 100%;
        }
      }
      span {
        display: inline-block;
        font-size: 26 / @w2;
      }
    }
  }
}
</style>
